<template>
  <v-select label="部门" clearable
            :loading="loading" :disabled="loading" :items="items" v-model="selected" :rules="rules" @click:clear="clear"/>
</template>

<script>
export default {
  name: "GroupSelector",
  props: {
    value: String,
    rules: Array
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      loading: false,
      items: []
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$axios.get("/groupNames").then(
          response => {
            this.loading = false;
            if (response && response.data) {
              this.items = response.data;
              console.log(this.items);
            }
          }
      );
    },
    clear() {
      this.selected = null;
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped>

</style>